import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 7CEC48C5-3A70-4BA2-9FB8-A383387DC4A1
 * name gas-cylinder
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gas-cylinder.svg
 * tags
 */
export const GasCylinderIcon = createSvgIcon(<><path d="M16,9V14L16,20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V14L8,9C8,7.14 9.27,5.57 11,5.13V4H9V2H15V4H13V5.13C14.73,5.57 16,7.14 16,9Z" /></>, 'GasCylinderIcon');
export default GasCylinderIcon